module.exports = __webpack_public_path__ + "static/media/logo_esn_invert_nl.c55de1df.svg";